var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"list":_vm.list,"infiniteId":_vm.loadingId,"headers":_vm.headers,"loading":_vm.loading},on:{"load":_vm.fetchList,"reload":_vm.reloadList},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('login-personalize-list-item',{attrs:{"item":slotProps.item},on:{"deleted":_vm.reloadList}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }